"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@lingui/core");
var _react = require("@lingui/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var Title = function Title(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react2.default.createElement(_react.I18nProvider, {
    i18n: _core.i18n
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: "dhig-mb-4"
  }, /*#__PURE__*/_react2.default.createElement("h1", {
    className: "headline-large dhig-typography-headline-large dhig-mb-6 caas-title"
  }, text)));
};
var _default = Title;
exports.default = _default;
Title.propTypes = {
  /**
   * Title text.
   */
  text: _propTypes.default.string
};
Title.defaultProps = {
  text: ''
};